"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const loglevel_1 = __importDefault(require("loglevel"));
/**
 * A custom logger to combine sentry and loglevel
 * @ignore
 */
class Logger {
    constructor() {
        /**
         * Default log level
         */
        this.level = 'debug';
        loglevel_1.default.setLevel('debug');
    }
    trace(...args) {
        loglevel_1.default.trace(...args);
    }
    info(...args) {
        loglevel_1.default.info(...args);
    }
    debug(...args) {
        loglevel_1.default.debug(...args);
    }
    warn(...args) {
        loglevel_1.default.warn(...args);
    }
    error(...args) {
        loglevel_1.default.error(...args);
    }
    setLevel(level) {
        this.level = level;
        loglevel_1.default.setLevel(level);
    }
    setConferenceId(conferenceId) { }
    setUserContext(data) { }
}
/**
 * @ignore
 */
const logger = new Logger();
/**
 * @ignore
 */
exports.default = logger;
